import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

/** The one <select> style — previously copy-pasted as `selectCls` in three files. */
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        'w-full rounded-md border border-border bg-surface px-2 py-1.5 text-sm text-fg',
        'focus:border-primary focus:outline-none',
        className,
      )}
      {...props}
    />
  ),
);
Select.displayName = 'Select';
